import * as React from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import { Box, Button, MenuItem, Typography } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import { getDashboardData } from "../../http/auth";
import Spinner from "../../components/Spinner";
import { useNavigate } from "react-router-dom";
import AboutTable from "./AboutTable";
import { showToast } from "../../store/slices/common";
import { useDispatch } from "react-redux";
import {
  downloadReport,
  getAboutYouUserList,
  getExpenseUserList,
  getIncomeUserList,
} from "../../http/dashboard";
import IncomeTable from "./IncomeTable";
import ExpenseTable from "./ExpenseTable";
// import {DateRangePicker} from "react-date-range"
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import { Download } from "@mui/icons-material";
const { RangePicker } = DatePicker;
export default function Dashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [selectedType, setSelectedType] = React.useState("yearly");
  const [listData, setListData] = React.useState([]);
  const [type, setType] = React.useState("about");
  const [totalCount, setTotalCount] = React.useState(0);
  const [dateFilters, setDateFilters] = React.useState([]);
  React.useEffect(() => {
    if (type === "about") {
      fetchAboutYouDetails(page, dateFilters);
    } else if (type === "income") {
      fetchIncomeDetails(page, dateFilters);
    } else {
      fetchExpenseDetails(page, dateFilters);
    }
  }, [type, selectedType, page, dateFilters]);
  const fetchAboutYouDetails = async (initPage, dateFiltersNew) => {
    try {
      setLoading(true);
      const payload = {
        page: initPage + 1 || page + 1,
      };
      if (dateFiltersNew?.length > 0) {
        const isSame =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DD") ===
          dayjs(dateFiltersNew[1]).format("YYYY-MM-DD");
        payload["startDate"] =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        if (isSame) {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDT") + "23:59:00.000Z";
        } else {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        }
      } else {
        payload["period"] = selectedType;
      }
      const res = await getAboutYouUserList(payload);
      const list = res?.data?.data?.report;
      setListData(list);
      setTotalCount(res.data?.data?.totalUsers);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  };
  const fetchIncomeDetails = async (initPage, dateFiltersNew) => {
    try {
      const payload = {
        page: initPage + 1 || page + 1,
      };
      if (dateFiltersNew?.length > 0) {
        const isSame =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DD") ===
          dayjs(dateFiltersNew[1]).format("YYYY-MM-DD");
        payload["startDate"] =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        if (isSame) {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDT") + "23:59:00.000Z";
        } else {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        }
      } else {
        payload["period"] = selectedType;
      }
      setLoading(true);
      const res = await getIncomeUserList(payload);
      const list = res?.data?.data?.report;
      setListData(list);
      setTotalCount(res.data?.data?.totalIncome);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  };
  const fetchExpenseDetails = async (initPage, dateFiltersNew) => {
    try {
      setLoading(true);
      const payload = {
        page: initPage + 1 || page + 1,
      };
      if (dateFiltersNew?.length > 0) {
        const isSame =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DD") ===
          dayjs(dateFiltersNew[1]).format("YYYY-MM-DD");
        payload["startDate"] =
          dayjs(dateFiltersNew[0]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        if (isSame) {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDT") + "23:59:00.000Z";
        } else {
          payload["endDate"] =
            dayjs(dateFiltersNew[1]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        }
      } else {
        payload["period"] = selectedType;
      }
      const res = await getExpenseUserList(payload);
      const list = res?.data?.data?.report;
      setListData(list);
      setTotalCount(res.data?.data?.totalIncome);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  };

  const handleChangePage = (evt, pageNum) => {
    setPage(pageNum);
  };

  const handleFetch = (dateFiltersNew) => {
    if (type === "about") {
      fetchAboutYouDetails(0, dateFiltersNew);
    } else if (type === "income") {
      fetchIncomeDetails(0, dateFiltersNew);
    } else {
      fetchExpenseDetails(0, dateFiltersNew);
    }
  };
  const items = [
    {
      label: "Daily",
      value: "daily",
    },
    {
      label: "Weekly",
      value: "weekly",
    },
    {
      label: "Monthly",
      value: "monthly",
    },
    {
      label: "Yearly",
      value: "yearly",
    },
  ];
  const handleDefault = () => {
    setPage(0);
    setDateFilters([]);
    setSelectedType("yearly");
  };

  const handleDownloadReport = async () => {
    try {
      setLoading(true);
      const payload = {
        report: type === "about" ? "user" : type,
      };
      if (dateFilters?.length > 0) {
        const isSame =
          dayjs(dateFilters[0]).format("YYYY-MM-DD") ===
          dayjs(dateFilters[1]).format("YYYY-MM-DD");
        payload["startDate"] =
          dayjs(dateFilters[0]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        if (isSame) {
          payload["endDate"] =
            dayjs(dateFilters[1]).format("YYYY-MM-DDT") + "23:59:00.000Z";
        } else {
          payload["endDate"] =
            dayjs(dateFilters[1]).format("YYYY-MM-DDTHH:mm:ss") + ".000Z";
        }
      } else {
        payload["period"] = selectedType;
      }
      const res = await downloadReport(payload);
      setLoading(false);
      window.open(res.data.data?.fileUrl);
    } catch (err) {
      setLoading(false);
      dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  };
  return (
    <DashboardWrapper heading={"Reports"}>
      {!loading ? (
        <>
          <Box
            sx={{
              display: "flex",
              alignContent: "center",
              justifyContent: "space-between",
              marginBottom: "15px",
            }}
          >
            <Box>
              <Button
                sx={
                  type === "about"
                    ? {
                        background: "#0832DE",
                        color: "#fff",
                        border: "1px solid #0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginRight: "20px",
                        ":hover": {
                          background: "#0832DE",
                        },
                      }
                    : {
                        border: "1px solid #0832DE",
                        color: "#0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginRight: "20px",
                      }
                }
                onClick={() => {
                  setType("about");
                  handleDefault();
                }}
              >
                About
              </Button>
              <Button
                sx={
                  type === "income"
                    ? {
                        background: "#0832DE",
                        color: "#fff",
                        border: "1px solid #0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginRight: "20px",
                        ":hover": {
                          background: "#0832DE",
                        },
                      }
                    : {
                        border: "1px solid #0832DE",
                        color: "#0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginRight: "20px",
                      }
                }
                onClick={() => {
                  setType("income");
                  handleDefault();
                }}
              >
                Income
              </Button>
              <Button
                sx={
                  type === "expense"
                    ? {
                        background: "#0832DE",
                        color: "#fff",
                        border: "1px solid #0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                        ":hover": {
                          background: "#0832DE",
                        },
                      }
                    : {
                        border: "1px solid #0832DE",
                        color: "#0832DE",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontWeight: 500,
                      }
                }
                onClick={() => {
                  setType("expense");
                  handleDefault();
                }}
              >
                Expenses
              </Button>
            </Box>
            <Box display={"flex"} alignItems={"center"}>
              <Box marginRight={"15px"}>
                <RangePicker
                  value={dateFilters}
                  onChange={(datesArr) => {
                    setPage(0);
                    setDateFilters(datesArr);
                    handleFetch(datesArr);
                  }}
                />
              </Box>
              <Box>
                <Select
                  // defaultValue="yearly"
                  style={{ width: 120 }}
                  onChange={(e) => {
                    setSelectedType(e);
                    setPage(0);
                    setDateFilters([]);
                  }}
                  value={selectedType}
                  options={items}
                />
              </Box>
              <Box>
                <Button
                  sx={{
                    border: "1px solid #0832DE",
                    color: "#0832DE",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: 500,
                    height: "32px",
                    marginLeft: "15px",
                  }}
                  onClick={handleDownloadReport}
                >
                  <Download />
                  <p>Report</p>
                </Button>
              </Box>
            </Box>
          </Box>
          <Box>
            {type === "about" ? (
              <AboutTable
                listData={listData}
                handleChangePage={handleChangePage}
                page={page}
                totalCount={totalCount}
              />
            ) : type === "income" ? (
              <IncomeTable
                listData={listData}
                handleChangePage={handleChangePage}
                page={page}
                totalCount={totalCount}
              />
            ) : (
              <ExpenseTable
                listData={listData}
                handleChangePage={handleChangePage}
                page={page}
                totalCount={totalCount}
              />
            )}
          </Box>
        </>
      ) : (
        <Spinner />
      )}
    </DashboardWrapper>
  );
}
